<template lang="pug">
div.body-question
  div.modal-header
    span.question-modal-title {{title}}
    span.question-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body.question-custom-body
    p.question-content {{content}}
  div.modal-footer.question-custom-footer
    div.row
      div.col-md-6.col-12
        div.text-right
          a.question-btn-continue.btn(@click='validateDelete()') Xác nhận
      div.col-md-6.col-12
        div.text-left
          a.question-btn-back.btn(@click="$emit('close')") Hủy yêu cầu
</template>
<script>
export default {
  props: {
    saveFunction: Function,
    title: String,
    content: String,
    type: Number
  },
  methods: {
    validateDelete() {
      if (this.type) {
        this.saveFunction({ type: this.type })
        this.$nextTick(() => {
          this.$emit('close')
        })
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-question {
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  font-family: 'adobe-clean', sans-serif;
  .question-modal-title {
    float: left;
    font-size: 17px;
  }
  .question-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .question-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .question-content {
    margin-bottom: 15px;
    font-size: 15px;
  }
  .question-email {
    margin-top: 0px; 
    margin-bottom: 0px;
    padding-bottom: 10px;
  }
  .question-btn-continue {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 20px;
  }
  .question-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .question-custom-footer {
    padding: 0;
    border: 0;
  }
  .question-custom-body {
    padding-bottom: 0;
  }

// cellphones
@media (max-width: 414px) {
  .question-email {
    margin-bottom: -10px
  }
  .question-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
    padding: 12px;
    margin-top: 0px;
  }
  .question-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
    margin-top: 0px;
    padding: 12px 20px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popupLock.vue?162ae208